import { Edit, translate } from "react-admin";
import React from "react";

import LineForm from "./LineForm";

const LineTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("group.group")}`} {record ? `"${record.name}"` : ""}
    </span>
  );
};

const Title = translate(LineTitle);

export const LineEdit = props => (
  <Edit title={<Title />} {...props}>
    <LineForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/line/LineEdit.js